import { useTranslation } from "react-i18next";
import { useApi } from "../contexts/ApiProvider";
import useDialog from "../contexts/DialogProvider";
import { useSnackbar } from "../contexts/SnackbarProvider";

const useCreateData = () => {
  const showMessage = useSnackbar();
  const showDialog = useDialog();
  const api = useApi();
  const { t } = useTranslation();

  const createHandler = async <T>(
    itemTitle: string,
    createUrl: string,
    values: T
  ) => {
    const response = await api.post<T, null>(createUrl, values);
    if (response.ok) {
      showMessage({
        text: t("Created WHAT successfully", {
          what: itemTitle,
        }),
        severity: "success",
      });
    } else {
      showDialog({
        title: t("Request failed"),
        text: t("Please, try again."),
      });
    }
  };

  return createHandler;
};

export default useCreateData;
